import { render, staticRenderFns } from "./KitRenameDialog.vue?vue&type=template&id=0336d53a&scoped=true&"
import script from "./KitRenameDialog.vue?vue&type=script&lang=ts&"
export * from "./KitRenameDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0336d53a",
  null
  
)

export default component.exports